// import { Platform } from 'react-native';
import GeometryUtilities from './geometry-utilities';

export default class GeometryTranspiler {

    /*

        line <label> <label> <length> <unit> rotate <label> <angle> <angle D - degree R - radian>

        origin 100 100
        line 3 CM A B

        orgin 600 500
        line 4 CM B C rotate C 200 D

    */

    static keywords = [
        "origin",
        "line",
        "ray",
        "lineseg",
        "marklabel",
        "markangle",
        "rotatelabel"
    ];

    static supported_keywords = [
        "rotate"
    ]

    static getGeometryObjectForType(type) {

        type = type.toLowerCase();
        let obj = {};
        switch (type) {

            case 'line':
                obj = {

                    type: "LINE",
                    points: [],
                }
        }
    }

    static transpile(script, cmRatio, xOffset) {

        if (!script) return null;

        if (typeof script != 'string') return script;

        xOffset = parseFloat(xOffset);

        let payload = [];
        let grammarMap = {};
        script = script.replace(/\u21B5/g, '\n');
        let lines = script.split("\n");
        lines = lines.map(line => line.trim());

        for (let i = 0; i < lines.length; i++) {

            let line = lines[i];
            let _tokens = line.split(" ");
            let tokens = [];

            _tokens.map(token => {

                token = token.trim();
                if (token.length != 0)
                    tokens.push(token);
            });

            /*
                If the script line is "origin"
            */
            if (tokens[0] == 'origin' && tokens.length == 3) {

                grammarMap['origin'] = {
                    x: parseFloat(tokens[1]) * cmRatio + xOffset,
                    y: parseFloat(tokens[2]) * cmRatio
                }

                continue;
            }

            /*
                If the script line is "line/ingseg/ray"
            */

            if ((tokens[0] == 'line' || tokens[0] == 'lineseg' || tokens[0] == 'ray')
                && (tokens.length == 5 || tokens.length == 9)) {

                let obj = {

                    type: "LINE",
                    lineType: tokens[0],
                    length: tokens[1],
                    unitType: tokens[2],
                    points: [],
                    _degree: 0,
                    isReadOnly: true
                };

                let l1 = {
                    type: "TEXT_LABEL",
                    isReadOnly: true,
                    points: []
                };

                let l2 = {
                    type: "TEXT_LABEL",
                    isReadOnly: true,
                    points: []
                };

                let length = parseFloat(tokens[1]);
                let lengthInPixels = GeometryUtilities.centimeterForPixels(length, cmRatio);

                let origin = grammarMap['origin'];

                if (origin) {

                    obj.points.push({
                        x: origin.x,
                        y: origin.y
                    });

                    l1.points.push({
                        x: origin.x,
                        y: origin.y,
                        label: tokens[3],
                        radius: 0.78,
                        rotationAngle: 0
                    });

                    grammarMap[tokens[3]] = {
                        x: origin.x,
                        y: origin.y
                    }

                    obj.points.push({
                        x: origin.x + lengthInPixels,
                        y: origin.y
                    });

                    l2.points.push({
                        x: origin.x + lengthInPixels,
                        y: origin.y,
                        label: tokens[4],
                        radius: 0.78,
                        rotationAngle: 0
                    });

                    grammarMap[tokens[4]] = {
                        x: origin.x + lengthInPixels,
                        y: origin.y,
                    }


                    //line 4 CM B C rotate C 200 D
                    if (tokens[5] == 'rotate') {

                        if (l1.points[0].label == tokens[6]) {

                            let degree = parseFloat(tokens[7]);
                            let point = GeometryUtilities.rotatePointWithCenter(l1.points[0], l2.points[0], degree);
                            l1.points[0].x = obj.points[0].x = point.x;
                            l1.points[0].y = obj.points[0].y = point.y;

                            grammarMap[tokens[3]] = {
                                x: point.x,
                                y: point.y
                            }

                        }
                        else if (l2.points[0].label == tokens[6]) {

                            let degree = parseFloat(tokens[7]);
                            let point = GeometryUtilities.rotatePointWithCenter(l2.points[0], l1.points[0], degree);
                            l2.points[0].x = obj.points[1].x = point.x;
                            l2.points[0].y = obj.points[1].y = point.y;

                            grammarMap[tokens[4]] = {
                                x: point.x,
                                y: point.y
                            }
                        }
                    }

                    payload.push(obj);
                    payload.push(l1);
                    payload.push(l2);

                    // only once we should use the key
                    delete grammarMap['origin'];
                }
                else {

                    let labelPoint = grammarMap[tokens[3]];

                    if (labelPoint) {

                        obj.points.push({
                            x: labelPoint.x,
                            y: labelPoint.y
                        });

                        l1.points.push({
                            x: labelPoint.x,
                            y: labelPoint.y,
                            label: tokens[3],
                            radius: 0.78,
                            rotationAngle: 0
                        });

                        if (!grammarMap[tokens[3]]) {
                            grammarMap[tokens[3]] = {
                                x: labelPoint.x,
                                y: labelPoint.y
                            }
                        }

                        obj.points.push({
                            x: labelPoint.x + lengthInPixels,
                            y: labelPoint.y
                        });

                        l2.points.push({
                            x: labelPoint.x + lengthInPixels,
                            y: labelPoint.y,
                            label: tokens[4],
                            radius: 0.78,
                            rotationAngle: 0
                        });

                        if (!grammarMap[tokens[4]]) {
                            grammarMap[tokens[4]] = {
                                x: labelPoint.x + lengthInPixels,
                                y: labelPoint.y,
                            }
                        }

                        //line 4 CM B C rotate C 200 D
                        if (tokens[5] == 'rotate') {

                            if (l1.points[0].label == tokens[6]) {

                                let degree = parseFloat(tokens[7]);
                                let point = GeometryUtilities.rotatePointWithCenter(l1.points[0], l2.points[0], degree);
                                l1.points[0].x = obj.points[0].x = point.x;
                                l1.points[0].y = obj.points[0].y = point.y;
                                obj._degree = degree;

                                grammarMap[tokens[3]] = {
                                    x: point.x,
                                    y: point.y
                                }
                            }
                            else if (l2.points[0].label == tokens[6]) {

                                let degree = parseFloat(tokens[7]);
                                let point = GeometryUtilities.rotatePointWithCenter(l2.points[0], l1.points[0], degree);
                                l2.points[0].x = obj.points[1].x = point.x;
                                l2.points[0].y = obj.points[1].y = point.y;
                                obj._degree = degree;

                                grammarMap[tokens[4]] = {
                                    x: point.x,
                                    y: point.y
                                }
                            }
                        }

                        payload.push(obj);

                        let l1AlreadyAvaialbleInList = payload.filter(o => o.type == "TEXT_LABEL" && o.points[0].label == l1.points[0].label);
                        let l2AlreadyAvaialbleInList = payload.filter(o => o.type == "TEXT_LABEL" && o.points[0].label == l2.points[0].label);

                        if (l1AlreadyAvaialbleInList.length == 0)
                            payload.push(l1);

                        if (l2AlreadyAvaialbleInList.length == 0)
                            payload.push(l2);
                    }
                    else {
                        /* error in script */
                        return null;
                    }
                }

                continue;
            }

            /*

                marklabel D on BY at 4 CM
            */

            if (tokens[0] == 'marklabel') {

                if (tokens.length == 7) {
                    if (!(tokens[1].length == 1 && tokens[1] >= 'A' && tokens[1] <= 'Z')) return payload;
                    if (!(tokens[2] == 'on' || tokens[2] == 'ON')) return payload;
                    if (!(tokens[4] == 'at' || tokens[4] == 'AT')) return payload;

                    let lineObj = this.getLine(tokens[3], payload);

                    let length = parseFloat(tokens[5]);
                    let lengthInPixels = GeometryUtilities.centimeterForPixels(length, cmRatio);

                    let x = lineObj.points[0].x + lengthInPixels;
                    let y = lineObj.points[0].y;

                    let point = GeometryUtilities.rotatePointWithCenter({ x, y }, lineObj.points[0], lineObj._degree);

                    let l1 = {
                        type: "TEXT_LABEL",
                        isReadOnly: true,
                        points: []
                    };

                    l1.points.push({
                        x: point.x,
                        y: point.y,
                        label: tokens[1],
                        radius: 0.78,
                        rotationAngle: 0
                    });

                    payload.push(l1);
                } // marklabel A at 2 4
                else if (tokens.length == 5) {


                    if (!(tokens[1].length == 1 && tokens[1] >= 'A' && tokens[1] <= 'Z')) return payload;
                    if (!(tokens[2] == 'at' || tokens[2] == 'AT')) return payload;

                    let x = parseFloat(tokens[3]);
                    let y = parseFloat(tokens[4]);

                    x = GeometryUtilities.centimeterForPixels(x, cmRatio);
                    y = GeometryUtilities.centimeterForPixels(y, cmRatio);


                    let l1 = {
                        type: "TEXT_LABEL",
                        isReadOnly: true,
                        points: []
                    };

                    l1.points.push({
                        x: x + xOffset,
                        y: y,
                        label: tokens[1],
                        radius: 0.78,
                        rotationAngle: 0
                    });

                    payload.push(l1);
                }
            }

            /*

                markangle ABC 30 D rotate -20 D
            */

            if (tokens[0] == 'markangle' && (tokens.length == 4 || tokens.length == 7)) {

                if (!(tokens[1].length == 3)) return payload;

                if (isNaN(tokens[2])) {
                    return;
                }

                // let lseg1 = tokens[3].substring(0, 1);
                // let lseg2 = tokens[3].substring(1, 2);

                // let line1 = this.getLine(lseg1, payload);
                // let line2 = this.getLine(lseg2, payload);

                let labels = payload.filter(o => o.type == 'TEXT_LABEL' && (o.points[0].label == tokens[1][1]));

                if (labels.length > 0) {

                    let point = labels[0].points[0];

                    let l1 = {
                        type: "ANGLE_LABEL",
                        isReadOnly: true,
                        points: []
                    };

                    // if (Platform.OS == "ios") {

                    //     l1.points.push({
                    //         x: point.x,
                    //         y: point.y,
                    //         label: tokens[2],
                    //         radius: 0.78,
                    //         rotationAngle: parseInt(tokens[5]),
                    //         startAngle: 0,
                    //         endAngle: -parseFloat(tokens[2])
                    //     });
                    // }
                    // else {
                        l1.points.push({
                            x: point.x,
                            y: point.y,
                            label: tokens[2],
                            radius: 0.78,
                            rotationAngle: parseInt(tokens[5]),
                            startAngle: -parseFloat(tokens[2]),
                            endAngle: parseFloat(tokens[2])
                        });
                    // }

                    payload.push(l1);
                }

            }

            /*
                rotatelabel A 30 D
            */

            if (tokens[0] == 'rotatelabel' && tokens.length == 4) {

                if (isNaN(tokens[2])) {
                    return;
                }

                let labels = payload.filter(o => o.type == 'TEXT_LABEL' && (o.points[0].label == tokens[1]));

                if (labels.length > 0) {

                    let label = labels[0].points[0];
                    label.rotationAngle = parseFloat(tokens[2]);
                }

            }
        }

        return payload;
    }

    static getLine(lineseg, payload) {

        if (lineseg.length != 2) return null;

        let labels = payload.filter(o => o.type == 'TEXT_LABEL' && (o.points[0].label == lineseg[0] || o.points[0].label == lineseg[1]));

        if (labels.length != 2) return null;

        let lines = payload.filter(o => o.lineType == "line" || o.lineType == 'lineseg' || o.lineType == 'ray');
        let l = lines.filter(line => {

            let p1, p2,l1,l2;

            p1 = line.points[0];
            p2 = line.points[1];

            l1 = labels[0].points[0];
            l2 = labels[1].points[0];

            if (p1.x == l1.x && p1.y == l1.y) {

                if (p2.x == l2.x && p2.y == l2.y) {

                    return true;
                }
            }
        });

        if (l.length > 0) {
            return l[0]
        }

        return null;
    }
}